export default __webpack_public_path__ + "static/media/powered_by_profil.51a8489d.png";